import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import dayjs from "dayjs";
import Link from "next/link";
import axios from "axios";
import BlogTiles from "@/components/blogTiles";
import webengage from "@/webengage";
import mixpanel from "@/utils/mixpanel";
import { calculateReadingTime } from "@/pages/blogs/index";
import Head from "next/head";
import Breadcrumb from "@/components/BreadCrumb";
import useConfetti from "@/utils/confetti-2";
import MarketingNewPaidForm from "@/components/marketingPages/MarketingNewPaidForm";


export const POPUP_TIMESTAMP_KEY = "popup_last_shown";
export const DAY_IN_MS = 24 * 60 * 60 * 1000;
export async function getServerSideProps(context: any) {
  const slug = context.query.slug;
  const key = "ASTROLEARN_BLOG_LEAD_MC";

  try {
    const { data } = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_API}blogs/get-by-slug?slug=${slug}`,
      {
        headers: { "Accept-Encoding": "gzip,deflate,compress" },
      }
    );

    await axios.post(
      `${process.env.NEXT_PUBLIC_BASE_API}blogs/view-increment`,
      { id: data?.id },
      { headers: { "Accept-Encoding": "gzip,deflate,compress" } }
    );
    const { data: masterclassId } = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_API}key-value/${key}`
    );
    const { data: masterclassData } = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/landing-page/${masterclassId.data.value}`,
      {
        headers: {
          "Accept-Encoding": "gzip",
        },
      }
    );
    const { data: randomBlogs } = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_API}blogs?live=true&limit=3`,
      {
        headers: { "Accept-Encoding": "gzip,deflate,compress" },
      }
    );

    randomBlogs.filter((blog: any) => blog.slug !== slug).slice(0, 3);
    return {

      props: { blog: data, randomBlogs, masterclass: masterclassData?.data },
    };
  } catch (err) {
    console.error("Error fetching blogs:", err);
    return {
      props: {
        blog: [],
        randomBlogs: [],
                masterclass: {},

      },
    };
  }
}

export default function blogSlug({
  blog,
  randomBlogs,
  masterclass
}: {
  blog: any;
  randomBlogs: any;
  masterclass:any;
}) {
  useEffect(() => {
    const _webengage = webengage();
    if (_webengage) {
      _webengage.track("Blog viewed", {
        title: blog.title,
        author: blog.user,
        industry: blog?.category?.name,
        source: "Astrolearn",
      });
    }
  }, []);
  const [isLeadFormOpen, setIsLeadFormOpen] = useState(false);
  const [price, setPrice] = useState<PriceObj>({
    price: masterclass?.price,
    discountedPrice: "0",
    workshopTitle: masterclass?.title,
    source: "free_masterclass",
  });
const popConfetti  = useConfetti();
  useEffect(() => {
    const lastShown = localStorage.getItem(POPUP_TIMESTAMP_KEY);
    const lastShownTime = new Date(lastShown as string).getTime();
    const now = Date.now();
    const timeoutId = setTimeout(() => {
      if(!lastShown || now - lastShownTime >= DAY_IN_MS){
        setIsLeadFormOpen(true);
        popConfetti();
      }
    }, 3000);
    return () => {
      clearTimeout(timeoutId); 
    };
  }, []);

  return (
    <React.Fragment>
      <Head>
        <title>{blog.title}</title>
      </Head>
      <Layout childClassName="relative">
          <MarketingNewPaidForm
          isOpen={isLeadFormOpen}
          closeModal={() => setIsLeadFormOpen(false)}
          isPopUp={true}
          price={price}
          masterclass={masterclass}
          isFreeMc={true}
          type="modal"
          customCtaText="Register Now for Free"
          formHeading={`Congratulations! You have Unlocked  your Free LalKitab Masterclass`}
          btnClass="!bg-[#FF7700]"
          outerDialogClass="!items-center !p-3 "
          showEmailField={false}
          customSource="blog"
        />
        <div className="relative flex flex-col items-center justify-center text-white max-lg:fixed max-lg:top-0 bg-black/50 w-full h-[517px] max-lg:h-[400px] !font-lato">
          <Breadcrumb
            textColor="text-white"
            classNames="z-20 absolute top-20 left-4 lg:top-6 lg:left-6 w-full"
          />
          <img
            src={blog.coverImage}
            className="absolute top-0 object-cover h-[517px] max-lg:h-[400px] w-full mix-blend-darken"
            alt="thumbnail"
          />
          <div className="text-center z-10 w-full flex flex-col justify-center gap-4">
            <p className="text-[65px] max-lg:text-[30px] font-[700] px-10 text-center max-lg:px-5 leading-tight max-w-5xl mx-auto">
              {blog.title}
            </p>
            <p className="text-[30px] max-lg:text-[14.81px]">
              {dayjs(blog.createdAt).format("MMMM D, YYYY	")} |{" "}
              {calculateReadingTime(blog.content)} mins read
            </p>
          </div>
        </div>

        {/* --- Mobile View --- */}
        <section className="py-0 z-10 max-lg:sticky max-lg:top-12 inset-x-0 bg-[#EEEBE6] max-lg:mt-[320px] rounded-[15px] no-scrollbar max-lg:px-[10px]">
          <div className="flex flex-col gap-[15px] font-lato lg:hidden max-lg:rounded-t-xl lg:bg-[#FFFFFF] ">
            <div
              className="font-lato px-2 mt-5 prose text-left max-w-none"
              dangerouslySetInnerHTML={{
                __html: (blog.content as string)
                  .replaceAll(
                    "<h2>",
                    '<h2 style="color:white;text-align:left;line-height:1.4">'
                  )
                  .replaceAll(
                    "<p>",
                    "<p style='font-size:1.2em;letter-spacing:0px;line-height:1.4'>"
                  ),
              }}
            />
          </div>

          {/* --- Desktop View --- */}
          <div className="lg:px-[5%] lg:bg-[#FFFFFF] py-5">
            <div
              className="max-md:hidden !bg-none font-lato px-2 prose text-left max-w-3xl mx-auto"
              dangerouslySetInnerHTML={{
                __html: (blog.content as string)
                  .replaceAll(
                    "<h2>",
                    '<h2 style="color:white;text-align:left;line-height:1.4">'
                  )
                  .replaceAll(
                    "<p>",
                    "<p style='font-size:1.2em;letter-spacing:0px;line-height:1.4'>"
                  ),
              }}
            />
          </div>

          <section className="max-w-[1440px] mx-auto font-bold xl:px-8 xl:py-12 flex flex-col items-start gap-4 lg:gap-8 justify-start text-[#1A1A1A] max-lg:pl-[3px] pt-5 lg:pt-10 px-[5%]">
            <h4 className="text-5xl max-lg:text-2xl">
              You May Like these Blogs Too
            </h4>
            <div className="pb-5 flex flex-col lg:grid lg:grid-cols-2 max-lg:gap-6 gap-10 items-center justify-center">
              {randomBlogs?.map((blog: any) => (
                <Link
                  key={blog.slug}
                  href={`/blogs/${blog?.slug}`}
                  className="hover:no-underline hover:border-none hover:border-transparent w-full"
                  onClick={() =>
                    mixpanel.track("blog_card_click", {
                      blog: blog?.slug,
                    })
                  }
                >
                  <BlogTiles
                    blog={blog}
                    minutesRead={calculateReadingTime(blog.content)}
                  />
                </Link>
              ))}
            </div>
          </section>
        </section>
      </Layout>
    </React.Fragment>
  );
}
